<template>
  <div class="row">
    <div class="col-12">
      
      <div
        class="card mb-25 border-0 rounded-0 bg-white letter-spacing contact-card"
      >
        <div class="card-body p-20 p-md-25 p-lg-30">
          <div class="mb-2" style="border-bottom: 1px dashed #d2cfe4;">
           <div
            class="user-info d-sm-flex align-items-center justify-content-between mb-30"
          >
            <div class="d-flex align-items-center">
              <div class="image">
                <img v-if="userData?.pic"
                  :src="userData.pic"
                  class="rounded-circle"
                  width="85"
                  height="85"
                  alt="user"
                />

                 <img
                  v-else
                  :src="require('@/assets/images/NoImage.png')"
                  class="rounded-circle"
                  width="85"
                  height="85"
                  alt="user"
                />
              </div>
              <div class="ms-15 ms-md-20">
                <h5 class="text-black fw-black mb-1">{{ userData?.name }}</h5>
                <span class="d-block text-muted">{{ userData?.email }}</span>
                <span
                  class="d-block text-black fs-md-15 fs-lg-16 fw-medium mb-8"
                >
                  {{ userData?.type }}
                </span>
              </div>
            </div>
          </div> 
          </div>
           

          <form @submit.prevent="saveProfile">
            <div class="row mb-4">
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    First Name
                  </label>
                  <input
                    type="text"
                    class="form-control shadow-none rounded-0 text-black"
                    placeholder="e.g. Adam"
                    v-model="userData.name"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    CIN
                  </label>
                  <input
                    type="text"
                    class="form-control shadow-none rounded-0 text-black"
                    placeholder="e.g. Adam"
                    v-model="userData.cin"
                  />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Email Address
                  </label>
                  <input
                    type="email"
                    class="form-control shadow-none rounded-0 text-black"
                    placeholder="e.g. adam127704@gmail.com"
                    v-model="userData.email"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Phone No
                  </label>
                  <input
                    type="text"
                    class="form-control shadow-none rounded-0 text-black"
                    placeholder="e.g. +001 321 4567"
                    v-model="userData.phone"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Password
                  </label>
                  <input
                    type="passowrd"
                    v-model="userData.password"
                    class="form-control shadow-none rounded-0 text-black"
                    placeholder="e.g. **************"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Confirm Password
                  </label>
                  <input
                    type="passowrd"
                    v-model="userData.password_confirmation"
                    class="form-control shadow-none rounded-0 text-black"
                    placeholder="e.g. **************"
                  />
                </div>
              </div>
              <div class="col-12">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Address
                  </label>
                  <textarea
                    class="form-control shadow-none fs-md-15 text-black"
                    v-model="userData.adresse"
                  ></textarea>
                </div>
              </div>

              <div class="col-12">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Upload Your Profile Picture
                  </label>
                  <input
                    class="form-control fs-15 text-black shadow-none"
                    type="file"
                    id="formFile"
                  />
                </div>
              </div>

              <div class="col-md-12">
                <div class="d-flex align-items-center justify-content-between">
                  <button
                    class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                    type="submit"
                  >
                    Save Profile
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive } from "vue";
import api from "@/utils/axios";
import { useAuthStore } from "@/stores/auth";

export default defineComponent({
  name: "AboutContent",
  components: {},
  setup() {
    const auth = useAuthStore();
    const user = auth.user;
    const userData = reactive<Record<string, any>>({});

    onMounted(async () => {
      try {
        const response = await api.get(`/api/auth/user_account/${user?.id}`);
        Object.assign(userData, response.data); // copy all keys into the reactive object
        // console.log("Fetched user account:", userData);
      } catch (error) {
        console.error("Error fetching user account:", error);
      }
    });

    // Save Profile function
    const saveProfile = async () => {
      try {
        const formData = new FormData();
        formData.append("name", userData.name);
        formData.append("cin", userData.cin);
        formData.append("email", userData.email);
        formData.append("phone", userData.phone);
        formData.append("adresse", userData.adresse);

        // Handle optional password
        if (userData.password) {
          formData.append("password", userData.password);
          formData.append(
            "password_confirmation",
            userData.password_confirmation
          );
        }

        // Handle file (profile picture)
        const fileInput = document.querySelector<HTMLInputElement>("#formFile");
        if (fileInput?.files?.[0]) {
          formData.append("pic", fileInput.files[0]);
        }

        const response = await api.post(
          `/api/auth/edit_user1/${auth.user?.id}`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        if (response.data.success) {
          console.log("Profile updated:", response.data);

          // update Pinia store user
          auth.setUser(response.data.user);

          // alert("Profile saved successfully ✅");
        } else {
          console.error("Profile update failed:", response.data);
        }
      } catch (error: any) {
        console.error(
          "Error saving profile:",
          error.response?.data || error.message
        );
        alert("Error saving profile ❌");
      }
    };
    return {
      user,
      userData,
      saveProfile,
    };
  },
});
</script>